import React from 'react';
import PropTypes from 'prop-types';
import { behaviourColors } from './constants';

/**
 * Button which changes the currently selected impulse.
 * @param {*} props 
 */
const ImpulseButton = ({ impulse, type, setSelectedImpulse }) => {
    let color = behaviourColors[impulse];
    let symbol = impulse === "positive" ? "+" : impulse === "neutral" ? "~" : impulse === "negative" ? "-" : "";

    const buttonStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '6px 12px',
        fontSize: '1.2em',
        borderRadius: '4px',
        color: '#fff',
        background: color,
        border: `1px solid ${color}`,
        cursor: 'pointer',
        height: 'auto',
    };

    const symbolStyle = {
        fontSize: '1.8em',
        marginRight: '1px',
        marginLeft: '1px',
        marginBottom: '1px',
        marginTop: '1px',
    };

    return (
        <button
            className={`btn impulse-button btn-${color}`}
            type="button"
            onClick={() => {
                console.log(`Impulse button clicked: impulse=${impulse}, type=${type}`);
                setSelectedImpulse(impulse);  // Speichern des Impulses in der Elternkomponente
            }}
            style={buttonStyle}>
            <span style={symbolStyle}>{symbol}</span>
        </button>
    );
}

ImpulseButton.propTypes = {
    impulse: PropTypes.string.isRequired,
    type: PropTypes.string,
    setSelectedImpulse: PropTypes.func.isRequired
}

export default ImpulseButton